// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__11DGC","label":"SetPasswdForm_label__2-mQr"};